export default __webpack_public_path__ + "static/media/icon-pathwayreport_sugar.9ffd9953.png";